import { ROUTES } from "../../../../module/constants";
import { generalConst } from "../../../../module/globalInterface";

export const TEMPLATE_SMS_MGMT_CONSOLE_ADMIN_URLS: generalConst = {
  BASE_URL: ROUTES.ADMIN_TEMPLATE_SMS_MGMT,
  STEP_TWO: `${ROUTES.ADMIN_TEMPLATE_SMS_MGMT}/stepTwo`,
};

export const STATE_IDENTIFIER = {
  CALL_STATE: "callState",
  LOADING: "loading",
  OPERATIONS: "operations",
  OPERATIONS_RAW: "operationsRaw",
  SELECTED_OPERATION: "selectedOperation",
};

export interface TemplateSmsRawItem extends TemplateSmsItem {
  body: string;
  defaultReceiver: string;
  defaultSender: string;
  encriptionKey?: string;
  language: string;
  maxRetry: number;
  retryDelay: number;
  type: string;
}

export interface TemplateSmsItem {
  id?: number;
  uniqueId: number;
  description: string;
  smsOperation: string;
}
